import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OptimizerData {
  optimizerData: any[];
  optimizerCurrent: any; // 👈 renamed to optimizerCurrent
}

interface OptimizerState {
  data: OptimizerData;
}

const initialState: OptimizerState = {
  data: {
    optimizerData: [],
    optimizerCurrent: null, // 👈 initial value
  },
};

const OptimizerSlice = createSlice({
  name: "optimizerData",
  initialState,
  reducers: {
    OptimizierDataUpdate: (
      state,
      action: PayloadAction<{ data: any[] }>
    ) => {
      state.data.optimizerData = action.payload.data;
    },

    // 👇 new reducer for optimizerCurrent
    OptimizierCurrentUpdate: (
      state,
      action: PayloadAction<{ current: any }>
    ) => {
      state.data.optimizerCurrent = action.payload.current;
    },
  },
});

export const { OptimizierDataUpdate, OptimizierCurrentUpdate } = OptimizerSlice.actions;
export default OptimizerSlice.reducer;
